module.exports = __webpack_public_path__ + "images/marker.0739c467.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/png/marker.png
// module id = 20
// module chunks = 0 1